(function() {
    'use strict';

    angular
        .module('liverunApp')
        .controller('SocialMediaController', SocialMediaController);

    SocialMediaController.$inject = ['SocialMedia'];

    function SocialMediaController(SocialMedia) {

        var vm = this;

        vm.socialMedias = [];

        loadAll();

        function loadAll() {
            SocialMedia.query(function(result) {
                vm.socialMedias = result;
                vm.searchQuery = null;
            });
        }
    }
})();
